import type { ComponentType } from 'react';
import { MyTimeOffWidget } from './widgets/my-time-off';
import { BirthdaysAnniversariesWidget } from './widgets/birthdays-anniversaries';
import { WhosOutTodayWidget } from './widgets/whos-out-today';
import { ProbationReviewsWidget } from './widgets/probation-reviews';
import { HeadcountThisMonthWidget } from './widgets/headcount-this-month';
import { OpenVacanciesWidget } from './widgets/open-vacancies';
import { UpcomingInterviewsWidget } from './widgets/upcoming-interviews';
import { StalledCandidatesWidget } from './widgets/stalled-candidates';
import { PipelineFunnelWidget } from './widgets/pipeline-funnel';
import { TeamTodayManagerWidget } from './widgets/team-today-manager';
import { TeamWorkloadWidget } from './widgets/team-workload';
import { TeamRequestsManagerWidget } from './widgets/team-requests-manager';
import { MyProjectsWidget } from './widgets/my-projects';

/**
 * Frontend dashboard widget registry: maps a widget `key` to its React component.
 *
 * Each widget adds its own `key: Component` entry here. The dashboard renderer silently
 * skips any key that has no registered component, so an unbuilt-but-assigned widget never
 * breaks the live dashboard.
 */
export const DASHBOARD_WIDGET_COMPONENTS: Record<string, ComponentType> = {
  myTimeOff: MyTimeOffWidget,
  birthdaysAnniversaries: BirthdaysAnniversariesWidget,
  whosOutToday: WhosOutTodayWidget,
  probationReviews: ProbationReviewsWidget,
  headcountThisMonth: HeadcountThisMonthWidget,
  openVacancies: OpenVacanciesWidget,
  upcomingInterviews: UpcomingInterviewsWidget,
  stalledCandidates: StalledCandidatesWidget,
  pipelineFunnel: PipelineFunnelWidget,
  teamTodayManager: TeamTodayManagerWidget,
  teamWorkload: TeamWorkloadWidget,
  teamRequestsManager: TeamRequestsManagerWidget,
  myProjects: MyProjectsWidget,
};
